import {
  Directive,
  HostBinding,
  Input,
  Self,
  Optional,
  Host,
  Inject,
  ElementRef
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { BaseInputStatusDirective } from '../form/input-status/base-input-status.directive';

import { InputGroupFieldComponent } from '../form/input-group/input-group-field.component';
import { FormRowComponent } from '../form/row/form-row.component';
import { FormComponent } from '../form/form.component';
import type { UntypedFormControl } from '@angular/forms';

@Directive({
  selector: 'input[tdWbInput], textarea[tdWbInput], td-wb-file-upload[tdWbInput]',
  exportAs: 'tdWbInput'
})
export class InputDirective extends BaseInputStatusDirective {
  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input('class') className: string;
  @Input('autocomplete') autoComplete: string | undefined;

  @HostBinding('attr.autocomplete')
  get autocomplete(): string {
    return (this.autoComplete === null || this.autoComplete === undefined) ? 'off' : this.autoComplete;
  }

  @HostBinding('attr.role') role: string;
  @HostBinding('class.td-wb-input') defaultInput: boolean = true;
  @HostBinding('class.td-wb-input--focus') focusState: boolean = false;
  @HostBinding('class.td-wb-input--hover') hoverState: boolean = false;

  @HostBinding('class') get hostClass(): string {
    return [this.className, this.inputClass].join(' ');
  }

  @HostBinding('attr.aria-describedby') describedBy: string;
  @HostBinding('attr.aria-invalid') ariaInvalid: string;

  @HostBinding('class.td-wb-error')
  get showErrorClass(): boolean {
    return this.inputGroupField === null ? this.control.invalid : this.isErrorState();
  }

  @HostBinding('attr.disabled')
  get attributeDisabled(): string {
    return this.disabled ? '' : null;
  }

  inputClass: string;

  private readonly control: UntypedFormControl;
  private _disabled: boolean;

  constructor(@Inject(ElementRef) elementRef: ElementRef,
              @Inject(NgModel) @Self() @Optional() ngModel: NgModel,
              @Inject(InputGroupFieldComponent) @Host() @Optional() inputGroupField: InputGroupFieldComponent,
              @Inject(FormComponent) @Optional() form: FormComponent,
              @Inject(FormRowComponent) @Host() @Optional() formRow: FormRowComponent) {
    super(elementRef, inputGroupField, form, formRow);
    this.control = ngModel.control;
  }

  setFocusState(focusState: boolean): void {
    if (!this.disabled) {
      this.focusState = focusState;
    }
  }

  setHoverState(hoverState: boolean): void {
    if (!this.disabled) {
      this.hoverState = hoverState;
    }
  }

  getValue(): string | number {
    return this.control.value;
  }

  setValue(value: unknown): void {
    this.control.setValue(value);
  }

  clear(): void {
    this.control.setValue(undefined);
  }

}
